export function SET_TABLE_FILTER(payload) {
	return {
		type: 'SET_TABLE_FILTER',
		payload: payload,
	};
}
